package uz.ferro.erp.feature.product.model

import kotlinx.serialization.Serializable
import uz.ferro.erp.feature.country.model.Country

@Serializable
data class ProductCountry(
    val id: Long? = null,
    val product: Product? = null,
    val country: Country? = null,
    val sort: Int? = null
)